export default "__VITE_ASSET__CPKvMYvX__"